export const getLocalDeepLinkUrlFromPathName = (location, messageId) => {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('messageId', messageId);
  return `${location.pathname}?${searchParams}`;
};
export const getFullDeepLinkUrlFromPathName = (location, messageId) => {
  return `${window.location.origin}${getLocalDeepLinkUrlFromPathName(location, messageId)}`;
};